// import useColorModes from '@github-ui/react-core/use-color-modes'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {BrandPageContent} from '../../brand/components/BrandPage'
import {toPayload} from '../../lib/types/payload'

import {HomeView} from './components/pageViews/HomeView/HomeView'
import {homePage} from './utils/content'
import {parseContentfulData} from './utils/parse-contentful'

export interface HomeProps {}

export const defaultProps: Partial<HomeProps> = {}

// eslint-disable-next-line no-empty-pattern
export function HomePage({}: HomeProps) {
  // TODO: Uncomment once Primer's `ThemeProvider` supports `auto` (SSR hydration issues otherwise)
  // const {colorMode} = useColorModes()
  // const pageColorMode = colorMode === 'day' ? 'light' : colorMode === 'night' ? 'dark' : 'auto'
  const pageColorMode = 'light'
  const payload = toPayload(useRoutePayload<unknown>())

  return (
    <BrandPageContent definition={homePage} colorMode={pageColorMode}>
      {content => (
        <HomeView
          copy={parseContentfulData(content)}
          runtime={{
            isLoggedIn: !!payload.userLoggedIn,
            isOrgAdmin: !!payload.orgAdminType,
            recentEvents: (payload.recentEvents ?? []).map(data => ({data})),
            featuredRepositories: payload.featuredRepositories ?? [],
          }}
        />
      )}
    </BrandPageContent>
  )
}
